import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTE_TITLES, BASE_TITLE } from '../config/routes';

const DynamicTitle = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        const moduleTitle = ROUTE_TITLES[path];

        if (moduleTitle) {
            document.title = `${BASE_TITLE} | ${moduleTitle}`;
        } else {
            document.title = BASE_TITLE;
        }
    }, [location]);

    return null;
};

export default DynamicTitle;
